export const BOOKING_STATUS = {
  CONFIRMED: "CONFIRMED",
  ADMIN_CONFIRMED: "ADMIN_CONFIRMED",
  DONE: "DONE",
  CHECKED_OUT: "CHECKED_OUT",
};

export const PERMISIONS = {
  READ: "read",
  ADD: "add",
  UPDATE: "update",
  DELETE: "delete",
};

export const GLOBAL_FEATURES = {
  EnquiryDashboard: "EnquiryDashboard",
  HKStaff: "HKStaff",
  HKSupervisor: "HKSupervisor",
  HideBlockRooms: "HideBlockRooms",
  HideUnBlockRooms: "HideUnBlockRooms",
  PaymentLink: "PaymentLink",
};

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
};

export const AGENT_REGISTRY = {
  OTA_ROOM_ASSIGNMENT_CONFIG_AGENT: "otaRoomAssignmentConfigAgent",
};

export const AI_RESPONSE_STATUS = {
  SUCCESS: "success",
  FAILED: "failed",
};

export const MOMENT_DATE_FORMATS = {
  YYYYMMDD_WITH_HYPHEN: "YYYY-MM-DD",
  DDMMYYYY_WITH_BACKSLASH: "DD/MM/YYYY",
};

export const AI_SCANNERS = {
  DOCUMENTAI: "DOCUMENTAI",
  IDGURU: "IDGURU",
  AMBIRSCAN: "AMBIRSCAN",
};

export const AI_SCAN_DOCUMENT_TYPES = {
  PASSPORT: "Passport",
  DRIVERS_LICENSE: "Drivers License",
};

export const DATE_FORMATS = {
  DATE_TIME_1: "dd MMM yyyy hh:mm a",
};
